import React from 'react';
import StaticContent from 'components/StaticContent';
import withConsortiaLayout from 'with/withConsortiaLayout';

function HelpConsortiaPage() {
  return <StaticContent src="/helpconsortia" />;
}

export default withConsortiaLayout(HelpConsortiaPage);
